import { EntityState } from '@/api/resources/entityState/entity-state'
import { commonStatusService } from '@/api/services/common/status/common-status.service'
import { EntityStatusState, StoreStateModel } from '@/store/root/root-store.model'
import { merge, keyBy } from 'lodash'
import { store } from '@/store/store'

export const CASE_STATES = {
    DRAFT: { code: 'DRAFT', class: 'state-draft', order: 10 },
    REGISTERED: { code: 'REGISTERED', class: 'state-primary', order: 20 },
    GROSSING_FINISHED: { code: 'GROSSING_FINISHED', class: 'state-process-5', order: 30 },
    LABORATORY_FINISHED: { code: 'LABORATORY_FINISHED', class: 'state-process-6', order: 40 },
    INFORMED: { code: 'INFORMED', class: 'state-alt-success-2', order: 50 },
    TRANSCRIBED: { code: 'TRANSCRIBED', class: 'state-alt-success-1', order: 60 },
    VALIDATED: { code: 'VALIDATED', class: 'state-success', order: 70 },
    IN_AMENDMENT: { code: 'IN_AMENDMENT', class: 'state-amendment', order: 80 }
}

class CaseState extends EntityState {
    protected get entityName(): string {
        return 'case'
    }

    async loadStates(): Promise<void> {
        if (!this.states.length) {
            const states = await commonStatusService.getCaseStates()
            const entityState: StoreStateModel<EntityStatusState[]> = {
                name: this.entityName,
                state: Object.values(
                    merge(
                        keyBy(states, 'code'),
                        keyBy(CASE_STATES, 'code')))
            }
            await store.dispatch('setEntityState', entityState)
        }
    }
}

export const caseState = new CaseState()
